import React, { useState, useEffect } from 'react';
// react component that copies the given text inside your clipboard
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { NavLink as NavLinkRRD, Link } from 'react-router-dom';
// reactstrap components
import {
  Card,
  Button,
  NavLink,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  UncontrolledTooltip,
  InputGroup,
} from 'reactstrap';
import { chartOptions, parseOptions, chartExample2 } from 'variables/charts.js';
import { Line, Bar } from 'react-chartjs-2';
import Chart from 'chart.js';
import axiosInstance from './../../helpers/axiosInstance';
import ReactCircleModal from 'react-circle-modal';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker, defaultStaticRanges } from 'react-date-range';
import Slicer from 'react-slicer';
import 'react-slicer/build/react-slicer.css';
import { useDispatch,useSelector } from 'react-redux';
import {
  cambiaruta,
  cambiasidebar,
  desactivasidebar,
  actulizaInitHome,
} from '../../Slicersreducers';
import NumberFormat from 'react-number-format';
import { es } from 'date-fns/locale';
import GenerateExcel from './GenerateExcel';
import MovementsProducts from './MovementsProducts';
import { cambiavalorpago, actualizarCheckboxs, actualizaropcionpago, actualizarBotonPagar } from 'Silicerreducerpayu';
import Check from "./Checksantander"
import OpcionesPagos from './PaymentOptions/OpcionesPagos';
import ListMethodPays from './PaymentOptions/ListMethodPays';
import BannerPse from './PaymentOptions/BannerPse';
import { Modal } from 'reactstrap';
import axios from 'axios';

const Comppago=(props)=>{
    const dispacher = useDispatch();
    const valorapagar=useSelector((state)=>state.pagopayu.valorpago)
    const listCheckbox = useSelector((state) => state.pagopayu.checkboxPago)
    const eleccionBanco = useSelector((state) => state.pagopayu.opcionpago)
    const habilitarBotonPagar = useSelector((state) => state.pagopayu.botonpagar)
    useEffect(()=>{
        if (props.pagomin == null || props.pagomin.toString().trim() == "" || props.pagomin == 0){
            dispacher(cambiavalorpago("0"))
        }
        else{
            dispacher(cambiavalorpago(props.pagomin.replace(/,/g,"")))
        }
        dispacher(actualizarCheckboxs([true, true, true]))
        dispacher(actualizaropcionpago("0"))
    }, [])

    const [cambioCheck, setCambioCheck] = useState(true)
    const [valueInput, setValueInput] = useState("")
    const [selectPago, setSelectPago] = useState("opcvalor")
    const [ipCliente, setipCliente] = useState("")
    const [Bancos, setBancos] = useState([])
    const [dataAlert, setdataAlert] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [valorFormato, setvalorFormato] = useState(valorapagar)

    const Alerts = (props) => {
        var data = props.data;
        var newsTemplate;
        if (data.length > 0) {
          newsTemplate = data.map(function (item, index) {
            return (
              <div class={item.type} role="alert">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  onClick={() => deleteAlert(item)}
                >
                  <span aria-hidden="true">×</span>
                </button>
                <span className="alert-inner--icon mr-3">
                  <i className={item.icon} />
                </span>{' '}
                <span class="alert-inner--text">{item.description}</span>
              </div>
            );
          });
        }
        return <div className="toast-bottom-right">{newsTemplate}</div>;
      };
    
      const deleteAlert = (alert) => {
        setdataAlert(dataAlert.filter((auxAlert) => auxAlert != alert));
      };
      const deleteTimeAlert = () => {
        setTimeout(function () {
          setdataAlert([]);
        }, 5000);
      };

    const handleSelectPago = () => {
        const posicionSeleccion = listCheckbox.indexOf(true)
        const valorPagoSeleccionado = document.getElementById("Pago" + posicionSeleccion).value;
        setvalorFormato(valorPagoSeleccionado);
        const valorPagoSeleccionadoFormato = parseFloat(valorPagoSeleccionado.replace(/,/g,""));
        const valorBalance = parseFloat(props.pagotot.replace(/,/g,""))
        if (valorPagoSeleccionadoFormato !== "" && valorPagoSeleccionadoFormato !== 0){
            if (valorPagoSeleccionadoFormato <= valorBalance){
                dispacher(cambiavalorpago(valorPagoSeleccionadoFormato))
                setSelectPago("elebanco")
                peticionBancos();
                peticionIP();
            }
            else{
                setdataAlert(
                    [{
                      description:
                        'El valor ingresado no es valido.',
                      type: 'alert alert-alert show alert-dismissible fade alert-danger',
                      icon: 'fas fa-exclamation-circle',
                    }]
                  );
                  deleteTimeAlert();
            }
        }
        else{
            setdataAlert(
                [{
                  description:
                    'El valor ingresado no es valido.',
                  type: 'alert alert-alert show alert-dismissible fade alert-danger',
                  icon: 'fas fa-exclamation-circle',
                }]
              );
              deleteTimeAlert();
        }
    }

    const handleSelectPse = (llaveMetodoPago) => {
        if (Bancos.length === 0){
            let mensajeAlerta = "Error al enviar la información. Por favor intente de nuevo."
            let tipoAlerta = "alert alert-alert show alert-dismissible fade alert-danger"
            let iconoAlerta = "fas fa-exclamation-circle"
            props.funcionpadre(mensajeAlerta, tipoAlerta, iconoAlerta);
        }
        else{
            setSelectPago("elepse")
            dispacher(actualizaropcionpago(llaveMetodoPago))
        }
    }

    const peticionBancos = async() => {
        try {
            setIsLoading(true)
            const apiBancos = "/WSGYG39_2/api/Consultas/Bancos";
            const response = await axios.get(apiBancos)
            setBancos(response.data.banks)
            setIsLoading(false)
        } catch (error) {
            setBancos([])
            console.log(error)
            setIsLoading(false)
        }
    }

    const peticionIP = async() => {
        try {
            const apiIP = 'https://api.ipify.org?format=json';
            const response = await axios.get(apiIP)
            const respuestaIP = response.data.ip
            setipCliente(respuestaIP)
        }
        catch (error) {
            console.log(error)
            setipCliente("")
        }
    }

    const handleInputChange = (event) => {
        event.preventDefault()
        let val = event.target.value;
        let onlyNumbers = val.replace(/\D/g, "");
        let formattedValue = new Intl.NumberFormat("es-CO").format(onlyNumbers);
        let valorconComas = formattedValue.replace(/\./g, ",");
        setValueInput(valorconComas)
    }

    const obtenerCookie = (name) => {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    const [inputsData, setInputsData] = useState({
        entidadBancaria: "",
        nombreTitular: "",
        tipoPersona: "",
        tipoIdentificacion: "",
        numeroIdentificacion: "",
        indicador: "",
        numeroTelefono: "",
        correo: obtenerCookie("email")
    });

    const validationRules = {
        entidadBancaria: { required: true, message: "" },
        nombreTitular: { required: true, message: "" },
        tipoPersona: { required: true, message: "" },
        tipoIdentificacion: { required: true, message: "" },
        numeroIdentificacion: { required: true, message: "" },
        indicador: { required: true, message: "" },
        numeroTelefono: { required: true, message: "" }
    }

    const enviarFormulario = async() => {
        if (validateFields()){
            if (ipCliente === "" || ipCliente === "undefined" ){
                let mensajeAlerta = "Error al enviar la información. Por favor intente de nuevo."
                let tipoAlerta = "alert alert-alert show alert-dismissible fade alert-danger"
                let iconoAlerta = "fas fa-exclamation-circle"
                props.funcionpadre(mensajeAlerta, tipoAlerta, iconoAlerta)
            }
            else{
                let Consulta = {
                    AccountNumber: props.accountNumber,
                    ProductType: "2",
                    Page: "NR005008",
                    BankCode: inputsData.entidadBancaria,
                    Parameters: [
                        valorapagar.toString(),
                        "COP",
                        inputsData.nombreTitular,
                        inputsData.correo,
                        inputsData.indicador + inputsData.numeroTelefono,
                        inputsData.entidadBancaria,
                        inputsData.tipoPersona,
                        inputsData.tipoIdentificacion,
                        inputsData.numeroIdentificacion,
                        ipCliente,
                        props.accountNumber,
                        valorapagar.toString(),
                        "PSE"
                    ]
                }
                console.log(Consulta)
                setIsLoading(true)
                try {
                    const consumoPago = "/WSGYG39_2/api/Consultas/Movimientos";
                    const responsepago = await axios.post(consumoPago, Consulta);
                    if (responsepago.status === 200){
                        if (responsepago.data.url_html !== null){
                            console.log(responsepago)
                            const urlHtml = responsepago.data.url_html;
                            const popup = window.open(urlHtml, '', 'width=600,height=400')
                            popup.focus()
                            dispacher(cambiavalorpago(0));
                            dispacher(actualizaropcionpago("0"));
                            dispacher(actualizarBotonPagar(true));
                            setIsLoading(false)
                            let mensajeAlerta = "La información se envio correctamente"
                            let tipoAlerta = "alert alert-alert show alert-dismissible fade alert-success"
                            let iconoAlerta = "fas fa-check-circle"
                            props.funcionpadre(mensajeAlerta, tipoAlerta, iconoAlerta)
                        }
                        else{
                            let errorExito
                            let errors = responsepago.data.errors
                            errors.forEach(error => {
                                errorExito = error.description
                            })
                            dispacher(cambiavalorpago(0));
                            dispacher(actualizaropcionpago("0"));
                            setIsLoading(false)
                            let mensajeAlerta = errorExito
                            let tipoAlerta = "alert alert-alert show alert-dismissible fade alert-danger"
                            let iconoAlerta = "fas fa-exclamation-circle"
                            props.funcionpadre(mensajeAlerta, tipoAlerta, iconoAlerta);
                        }
                    }
                    else {
                        const errorgenerado = responsepago.data.errors.map(error => error.description);
                        console.log(errorgenerado)
                        dispacher(cambiavalorpago(0));
                        dispacher(actualizaropcionpago("0"));
                        setIsLoading(false)
                        let mensajeAlerta = errorgenerado
                        let tipoAlerta = "alert alert-alert show alert-dismissible fade alert-danger"
                        let iconoAlerta = "fas fa-exclamation-circle"
                        props.funcionpadre(mensajeAlerta, tipoAlerta, iconoAlerta);
                    }
                } catch (error) {
                    let errorgenerado
                    let errors = error.response.data.errors;
                    errors.forEach(error => {
                        errorgenerado = error.description
                    })
                    dispacher(cambiavalorpago(0));
                    dispacher(actualizaropcionpago("0"));
                    setIsLoading(false)
                    let mensajeAlerta = errorgenerado
                    let tipoAlerta = "alert alert-alert show alert-dismissible fade alert-danger"
                    let iconoAlerta = "fas fa-exclamation-circle"
                    props.funcionpadre(mensajeAlerta, tipoAlerta, iconoAlerta);
                }
            }

        }
        else{
            return false;
        }
    }

    const [validation, setValidation] = useState(validationRules);

    const changeInputsForm = (e) => {
        const { name, value } = e.target
        if (name === "numeroTelefono"){
            const onlyNumbers = value.replace(/\D/g, "");
            setInputsData((prevState) => ({
                ...prevState,
                numeroTelefono: onlyNumbers
            }));
        }
        else {
            setInputsData((prevState) => ({
                ...prevState,
                [name]: value
            }))
        }
        console.log(inputsData);
    }

    const validateFields = () => {
        const newValidation = {};

        for (const field in validationRules) {
            const rules = validationRules[field];
            const value = inputsData[field]

            let isValid = true;
            let message = "";

            if ((rules.required && !value)) {
                isValid = false;
                message = "Este campo es requerido";
            }

            newValidation[field] = { isValid, message }
        }

        setValidation(newValidation)
        let isvalidform = false;
        for (const field in newValidation) { 
            if(newValidation[field].isValid == false){
                isvalidform = false;
                break;
            }else{
                isvalidform = true;
            }
            
        }
        return isvalidform;
    }

    switch (selectPago) {
        case "opcvalor":
            return(
                //inicio pago
                <div lg="12" xl="12" className="" style={{ width: 100 + '%' }}>
                    <Card className="mb-xl-0 shadow pl-5 pr-5">
                        <div className="bg-transparent row m-0">
                            <div class="card-profile-stats d-flex justify-content-init col">
                                <div style={{ textAlign: 'left' }}>
                                    <span class="heading">{props.Descript}</span>
                                    <span class="description">No. {props.accountNumber}</span>
                                </div>
                            </div>
                        </div>
                        <CardBody className="pb-1 row">
                            <div className="col-md-12">
                                <Row className='flexcolumcenter' style={{ marginBottom: 30 + 'px' }}>
                                    <div className='detalleprestamoscont'>
                                        <div className='flexcolumleftw90'>
                                            <div >
                                                <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}>
                                                    {' '}
                                                    Valor Deuda{' '}
                                                </h6>
                                                <h5 style={{ fontSize: 1.25 + 'rem' }}>
                                                    <NumberFormat
                                                    value={props.balance}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    prefix={'$'}
                                                    />
                                                </h5>
                                            </div>
                                            <div>
                                                <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}>
                                                    {' '}
                                                    <i className="fas fa-money-bill" /> Pago Total a la Fecha{' '}
                                                </h6>
                                                <h5 style={{ fontSize: 1.25 + 'rem' }}>
                                                    <NumberFormat
                                                    value={props.pagotot}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    prefix={'$'}
                                                    />
                                                </h5>
                                            </div>
                                        </div>
                                        <div className='flexcolumrigthw90'>
                                            <div >
                                                <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}>
                                                    {' '}
                                                    <i className="fas fa-money-bill" /> Pago Mínimo a la Fecha
                                                </h6>
                                                <h5 style={{ fontSize: 1.25 + 'rem' }}>
                                                    {' '}
                                                    <NumberFormat
                                                    value={props.pagomin}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    prefix={'$'}
                                                    />{' '}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                            </div>
                        </CardBody>
                        <div className='contenedor-opciones-pago' style={{display: "flex", flexDirection: "column", gap: "20px", alignItems: "center"}} >
                            <div style={{ display: "flex", justifyContent: "space-between", width: "550px" }}>
                                <div>
                                <Check mensaje={"Pago minimo"} 
                                    estadocheck={false} 
                                    idCheck={"0"} 
                                    permisocambio={listCheckbox[0]}></Check>
                                </div>
                                <div className="inputs-icons-borderbott" style={{ width: "400px" }}>
                                    <input
                                        maxLength={19}
                                        className="form-control h5 p-1"
                                        name="cuantiaSolicitada"
                                        placeholder="Cuantía solicitada"
                                        type="text"
                                        id="Pago0"
                                        readOnly
                                        value={props.pagomin}
                                        style={{
                                        fontSize: "14px",
                                        border: "none",
                                        width: "200px",
                                        height: "25px",
                                        padding: "0px 0px 0px 0px",
                                        margin: "0px 0px 0px 0px",
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", width: "550px" }}>
                                <div>
                                <Check mensaje={"Valor total"} 
                                    estadocheck={false} 
                                    idCheck={"1"} 
                                    permisocambio={listCheckbox[1]}></Check>
                                </div>
                                <div className="inputs-icons-borderbott" style={{ width: "400px" }}>
                                    <input
                                        maxLength={19}
                                        className="form-control h5 p-1"
                                        name="cuantiatotal"
                                        placeholder="Cuantía total"
                                        type="text"
                                        readOnly
                                        id="Pago1"
                                        value={props.pagotot}
                                        style={{
                                        fontSize: "14px",
                                        border: "none",
                                        width: "200px",
                                        height: "25px",
                                        padding: "0px 0px 0px 0px",
                                        margin: "0px 0px 0px 0px",
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", width: "550px" }}>
                                <div>
                                <Check mensaje={"Otro valor"} 
                                    estadocheck={false} 
                                    idCheck={"2"} 
                                    permisocambio={listCheckbox[2]} 
                                    funcionpadre={(id,est)=>{setCambioCheck(!est)}}></Check>
                                </div>
                                <div className="inputs-icons-borderbott" style={{ width: "400px" }}>
                                    <input
                                        maxLength={19}
                                        className="form-control h5 p-1"
                                        name="otroValor"
                                        type="text"
                                        id="Pago2"
                                        placeholder='Otro Valor'
                                        disabled={cambioCheck}
                                        value={valueInput}
                                        onChange={handleInputChange}
                                        style={{
                                        fontSize: "14px",
                                        border: "none",
                                        width: "400px",
                                        height: "25px",
                                        padding: "0px 0px 0px 0px",
                                        margin: "0px 0px 0px 0px",
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div style={{ margin: "30px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <button
                            onClick={() => handleSelectPago(true)}
                            className="btn btn-success"
                            disabled={Array.isArray(listCheckbox) && listCheckbox.every((valor) => valor)}>
                                Pagar
                            </button>
                        </div>
                    </Card>
                    <Alerts
                    data={dataAlert} />
                </div>
                //fin pago
            )
        case "elebanco":
            return(
                <div>
                    <h1>
                        Metodo de Pago
                    </h1>
                    <div 
                    style={{ marginTop: "50px" }} >
                    {
                        ListMethodPays.map((method, index) => (
                            <OpcionesPagos
                            key={method.key}
                            rutaimagen={method.rutaImagen}
                            nombrepago={method.nombrePago}
                            valorpago={valorFormato}
                            onClick={() => handleSelectPse(method.key)} />
                        ))
                    }
                    </div>
                    <Modal
                        className="modal-dialog-centered"
                        contentClassName="bg-transparent shadow-none"
                        isOpen={isLoading}
                        >
                            <div
                            tabIndex="-1"
                            style={{
                            position: "relative",
                            zIndex: "1050",
                            display: "block",
                            width: "100%",
                            height: "80vh"
                            }}
                            >
                            <div
                            style={{
                            textAlign: "center",
                            top: "50%",
                            position: "relative"
                            }}
                            >
                                    <img
                                    style={{ height: "100px" }}
                                    src={require("../../assets/img/icons/LoaderIDEA.gif").default}
                                    ></img>
                                </div>
                                <div class="modal-backdrop fade show"></div>
                                </div>
                            </Modal>
                </div>
            )
        case "elepse":
            return(
                <div>
                    <div>
                        <h1>
                            Metodo de Pago
                        </h1>
                    </div>
                    <div style={{ marginTop: "50px" }}>
                        <BannerPse />
                    </div>
                    <div style={{ marginTop: "50px" }}>
                        <form>
                            <InputGroup className="input-group-alternative mt-3 mb-3" style={{ display: "flex", flexDirection: "column" }}>
                                <div className='inputs-icons-borderbott'
                                style={{ width: "30%", margin: "auto" }}>
                                    <select placeholder='Seleccione una entidad bancaria'
                                    style={{ border: "none",
                                    width: "100%",
                                    fontSize: "14px",
                                    height: "33px", }}
                                    name='entidadBancaria'
                                    value={inputsData.entidadBancaria}
                                    onInput={changeInputsForm}>
                                        <option value="">Seleccione una entidad bancaria</option>
                                        {
                                            Bancos.map((item, index) => (
                                                <option key={index} value={item.pseCode}>
                                                    {item.description}
                                                </option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <div style={{ width: "30%", margin: "auto" }}>
                                {!validation.entidadBancaria.isValid && (
                                    <small style={{ color: "red" }}>
                                        {validation.entidadBancaria.message}
                                    </small>
                                )}
                                </div>
                            </InputGroup>

                            <InputGroup className="input-group-alternative mt-3 mb-3" style={{ display: "flex", flexDirection: "column" }}>
                                <div className='inputs-icons-borderbott'
                                style={{ width: "30%", margin: "auto" }}>
                                    <input
                                        onInput={changeInputsForm}
                                        value={inputsData.nombreTitular}
                                        className="form-control h5 p-1"
                                        placeholder="Nombre del Titular"
                                        name="nombreTitular"
                                        type="text"
                                        style={{
                                        fontSize: "14px",
                                        border: "none",
                                        width: "250px",
                                        height: "25px",
                                        padding: "0px 0px 0px 0px",
                                        margin: "0px 0px 0px 0px",
                                        }}
                                    />
                                </div>
                                <div style={{ width: "30%", margin: "auto" }}>
                                {!validation.nombreTitular.isValid && (
                                    <small style={{ color: "red" }}>
                                        {validation.nombreTitular.message}
                                    </small>
                                )}
                                </div>
                            </InputGroup>

                            <InputGroup className="input-group-alternative mt-3 mb-3" style={{ display: "flex", flexDirection: "column" }}>
                                <div className='inputs-icons-borderbott'
                                style={{ width: "30%", margin: "auto" }}>
                                    <select placeholder='Tipo de persona'
                                    style={{ border: "none",
                                    width: "100%",
                                    fontSize: "14px",
                                    height: "33px", }}
                                    name='tipoPersona'
                                    value={inputsData.tipoPersona}
                                    onInput={changeInputsForm}>
                                        <option value="">Tipo de persona</option>
                                        <option value="J">Juridica</option>
                                        <option value="N">Natural</option>
                                    </select>
                                </div>
                                <div style={{ width: "30%", margin: "auto" }}>
                                {!validation.tipoPersona.isValid && (
                                    <small style={{ color: "red" }}>
                                        {validation.tipoPersona.message}
                                    </small>
                                )}
                                </div>
                            </InputGroup>

                            <InputGroup className="input-group-alternative mt-3 mb-3" style={{ display: "flex", flexDirection: "column" }}>
                                <div className='inputs-icons-borderbott'
                                style={{ width: "30%", margin: "auto" }}>
                                    <select placeholder='Tipo de identificación'
                                    style={{ border: "none",
                                    width: "100%",
                                    fontSize: "14px",
                                    height: "33px", }}
                                    name="tipoIdentificacion"
                                    value={inputsData.tipoIdentificacion}
                                    onInput={changeInputsForm}>
                                        <option value="">Tipo de identificacion</option>
                                        <option value="CC">C.C. (Cédula de ciudadanía)</option>
                                        <option value="CE">C.E. (Cédula de extranjería)</option>
                                        <option value="CEL">CEL (Número móvil)</option>
                                        <option value="DE">D.E. (Documento de identicación extranjero)</option>
                                        <option value="IDC">IDC (Identificador único de cliente)</option>
                                        <option value="NIT">NIT (Número de identificación Tributario)</option>
                                        <option value="TI">T.I. (Tarjeta de Identidad)</option>
                                        <option value="PP">PP (Pasaporte)</option>
                                        <option value="RC">R.C. (Registro civil de nacimiento)</option>
                                    </select>
                                </div>
                                <div style={{ width: "30%", margin: "auto" }}>
                                {!validation.tipoIdentificacion.isValid && (
                                    <small style={{ color: "red" }}>
                                        {validation.tipoIdentificacion.message}
                                    </small>
                                )}
                                </div>
                            </InputGroup>

                            <InputGroup className="input-group-alternative mt-3 mb-3" style={{ display: "flex", flexDirection: "column" }}>
                                <div className='inputs-icons-borderbott'
                                style={{ width: "30%", margin: "auto" }}>
                                    <input
                                        className="form-control h5 p-1"
                                        placeholder="Numero de identificacion"
                                        type="text"
                                        name="numeroIdentificacion"
                                        value={inputsData.numeroIdentificacion}
                                        onInput={changeInputsForm}
                                        style={{
                                        fontSize: "14px",
                                        border: "none",
                                        width: "250px",
                                        height: "25px",
                                        padding: "0px 0px 0px 0px",
                                        margin: "0px 0px 0px 0px",
                                        }}
                                    />
                                </div>
                                <div style={{ width: "30%", margin: "auto" }}>
                                {!validation.numeroIdentificacion.isValid && (
                                    <small style={{ color: "red" }}>
                                        {validation.numeroIdentificacion.message}
                                    </small>
                                )}
                                </div>
                            </InputGroup>

                            <div style={{ width: "30%", display: "flex", gap: "10px", margin: "auto"}}>

                                <InputGroup className="input-group-alternative mt-3 mb-3" style={{ width: "35%" }}>
                                    <div className='inputs-icons-borderbott'
                                    style={{ width: "100%" }}>
                                        <select placeholder='Indicador'
                                        style={{ border: "none",
                                        width: "100%",
                                        fontSize: "11px",
                                        height: "33px", }}
                                        name="indicador"
                                        value={inputsData.indicador}
                                        onInput={changeInputsForm}>
                                            <option value="">Indicador</option>
                                            <option value="57">+ 57</option>
                                            <option value="1">+ 1</option>
                                            <option value="44">+ 44</option>
                                            <option value="49">+ 49</option>
                                            <option value="33">+ 33</option>
                                            <option value="81">+ 81</option>
                                            <option value="44">+ 86</option>
                                            <option value="49">+ 91</option>
                                            <option value="33">+ 61</option>
                                            <option value="81">+ 55</option>
                                        </select>
                                    </div>
                                </InputGroup>

                                <InputGroup className="input-group-alternative mt-3 mb-3" style={{ width: "70%" }}>
                                    <div className='inputs-icons-borderbott'
                                    style={{ width: "100%" }}>
                                        <input
                                            className="form-control h5 p-1"
                                            placeholder="Telefono"
                                            type="text"
                                            name="numeroTelefono"
                                            value={inputsData.numeroTelefono}
                                            onInput={changeInputsForm}
                                            style={{
                                            fontSize: "14px",
                                            border: "none",
                                            width: "250px",
                                            height: "25px",
                                            padding: "0px 0px 0px 0px",
                                            margin: "0px 0px 0px 0px",
                                            }}
                                        />
                                    </div>
                                </InputGroup>
                            </div>
                            <div style={{ width: "50%", display: "flex", gap: "10px", margin: "auto"}}>
                                    <div style={{ width: "40%", margin: "auto", textAlign: 'right' }}>
                                    {!validation.indicador.isValid && (
                                        <small style={{ color: "red" }}>
                                            {validation.indicador.message}
                                        </small>
                                    )}
                                    </div>
                                    <div style={{ width: "50%", margin: "auto" }}>
                                    {!validation.numeroTelefono.isValid && (
                                        <small style={{ color: "red" }}>
                                            {validation.numeroTelefono.message}
                                        </small>
                                    )}
                                    </div>
                                </div>
                        </form>

                        <div style={{ margin: "30px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <button
                            onClick={enviarFormulario}
                            className="btn btn-success">
                                    Pagar
                            </button>
                        </div>
                        <Alerts
                        data={dataAlert} />
                        <Modal
                        className="modal-dialog-centered"
                        contentClassName="bg-transparent shadow-none"
                        isOpen={isLoading}
                        >
                            <div
                            tabIndex="-1"
                            style={{
                            position: "relative",
                            zIndex: "1050",
                            display: "block",
                            width: "100%",
                            height: "80vh"
                            }}
                            >
                            <div
                            style={{
                            textAlign: "center",
                            top: "50%",
                            position: "relative"
                            }}
                            >
                                    <img
                                    style={{ height: "100px" }}
                                    src={require("../../assets/img/icons/LoaderIDEA.gif").default}
                                    ></img>
                                </div>
                                <div class="modal-backdrop fade show"></div>
                                </div>
                            </Modal>
                    </div>
                </div>
            )
    }
  }

  export default Comppago;